// extracted by mini-css-extract-plugin
export var actionIcon = "_rz-0";